import { createSlice } from '@reduxjs/toolkit';

const headerSlice = createSlice({
  name: 'header',
  initialState: {
    headerActions: [],
    navigationAction: null,
    navigationHelp: null,
    headerTitle: null,
    headerTitleDisabled: false,
  },
  reducers: {
    setHeaderActions(state, { payload }) {
      state.headerActions = payload;
    },
    appendHeaderActions(state, { payload }) {
      state.headerActions = [...state.headerActions, ...payload].sort((a, b) => a.order - b.order);
    },
    removeHeaderActions(state, { payload }) {
      state.headerActions = state.headerActions.filter((action) => !payload.includes(action.id));
    },
    resetHeaderActions(state) {
      state.headerActions = [];
    },
    setHeaderTitle(state, { payload }) {
      state.headerTitle = payload;
    },
    resetHeaderTitle(state) {
      state.headerTitle = null;
      state.headerTitleDisabled = false;
    },
    setHeaderTitleDisabled(state, { payload }) {
      state.headerTitleDisabled = payload;
    },
    setNavigationAction(state, { payload }) {
      if (!payload.title) throw new Error('Title is mandatory for navigation action');
      if (payload.type === 'button' && !payload.callback)
        throw new Error('Callback is mandatory for navigation action');
      state.navigationAction = payload;
    },
    resetNavigationAction(state) {
      state.navigationAction = null;
    },
    setNavigationHelp(state, { payload }) {
      if (!payload.title || !payload.callback) {
        throw new Error('Title and callback are mandatory for navigation help');
      }

      state.navigationHelp = payload;
    },
    resetNavigationHelp(state) {
      state.navigationHelp = null;
    },
  },
});

export const {
  setHeaderActions,
  appendHeaderActions,
  prependHeaderActions,
  removeHeaderActions,
  resetHeaderActions,
  setNavigationAction,
  resetNavigationAction,
  setNavigationHelp,
  resetNavigationHelp,
  setHeaderTitle,
  resetHeaderTitle,
  setHeaderTitleDisabled,
  resetHeaderTitleDisabled,
} = headerSlice.actions;

export default headerSlice.reducer;
